import React from 'react'
import {
  FormControl
} from 'react-bootstrap'
import {
  ToggleModal
} from 'components/Modal'
import classes from './DateInput.module.scss'
import DatePicker from 'components/DatePicker'

export class DateInput extends React.Component {
  state = {
    show: false
  }

  render () {
    const {
      value,
      onChange,
    } = this.props

    return (
      <ToggleModal
        ref={this.handleModalRef}
        show={this.state.show}
        onToggle={show => this.setState({ show })}
        backdrop
        attachment='top left'
        targetAttachment='bottom left'
      >
        <FormControl
          type='text'
          value={new Date(value).toString()}
        />
        <div className={classes.modal}>
          <DatePicker
            showHour
            date={value}
            onChange={(...args) => {
              onChange(...args)

              this.setState({ show: false })
            }}
          />
        </div>
      </ToggleModal>
    )
  }
}

export default DateInput
